import { inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export const provideSvgIcons = provideAppInitializer(() => {
  const matIconRegistry = inject(MatIconRegistry);
  const domSanitizer = inject(DomSanitizer);
  const svgIcons: { name: string; url: string }[] = [
    { name: 'notice', url: 'assets/images/exclamation.svg' },
    { name: 'great', url: 'assets/images/great.svg' },
    { name: 'good', url: 'assets/images/good.svg' },
    { name: 'ok', url: 'assets/images/ok.svg' },
    { name: 'lightbulb', url: 'assets/images/lightbulb.svg' },
    { name: 'happy-colored', url: 'assets/images/attitude/happy.svg' },
    { name: 'neutral-colored', url: 'assets/images/attitude/neutral.svg' },
    { name: 'sad-colored', url: 'assets/images/attitude/dislike.svg' },
    { name: 'happy', url: 'assets/images/attitude/happy-gray.svg' },
    { name: 'neutral', url: 'assets/images/attitude/neutral-gray.svg' },
    { name: 'sad', url: 'assets/images/attitude/dislike-gray.svg' },
    { name: 'gears', url: 'assets/images/gears.svg' },
    { name: 'close', url: 'assets/images/close.svg' },
    { name: 'search', url: 'assets/images/search.svg' },
    { name: 'chevron_down', url: 'assets/images/chevron_down.svg' },
    { name: 'chevron_down_white', url: 'assets/images/chevron_down_white.svg' },
    { name: 'delete', url: 'assets/images/delete.svg' },
    { name: 'grid_view', url: 'assets/images/grid-view.svg' },
    { name: 'list_view', url: 'assets/images/list-view.svg' },
    { name: 'heart', url: 'assets/images/heart.svg' },
    { name: 'heart-empty', url: 'assets/images/heart-empty.svg' },
    { name: 'linkedin', url: 'assets/images/linkedin-in-brands.svg' },
    { name: 'twitter', url: 'assets/images/twitter-brands.svg' },
    { name: 'facebook', url: 'assets/images/facebook-brands.svg' },
    { name: 'arrow', url: 'assets/images/arrow.svg' },
    { name: 'company', url: 'assets/images/company.svg' },
    { name: 'educator', url: 'assets/images/educator.svg' }
  ];

  svgIcons.forEach(icon =>
    matIconRegistry.addSvgIcon(icon.name, domSanitizer.bypassSecurityTrustResourceUrl(icon.url))
  );
});
